export const ribbonComponents_KioskV5 = [
  {
    screenTitle: "All",
    screenIndex: "none",
    screenWidth: 108,
    screenHeight: 192,
  },
  {
    screenTitle: "Start",
    screenIndex: "1",
    screenImage: "/img/customComponents/FilterRibbon_Intro_001.png",
    screenDescription: "Start screen on an idle kiosk",
    screenWidth: 108,
    screenHeight: 192,
    subScreenInfo: [
      {
        screenTitle: "Buttons",
        screenIndex: "1C",
        screenImage: "",
        screenDescription: "Background of home page",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 118,
        areaPositionY: 2,
        areaPositionX: 0,
      },
      {
        screenTitle: "Buttons",
        screenIndex: "1A",
        screenImage: "",
        screenDescription: "Optional takeaway / eat-in buttons",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 98,
        areaHeight: 24,
        areaPositionY: 123,
        areaPositionX: 5,
      },
      {
        screenTitle: "Languages",
        screenIndex: "1B",
        screenImage: "",
        screenDescription: "Selectable language flags",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 88,
        areaHeight: 27,
        areaPositionY: 157,
        areaPositionX: 10,
      },
    ],
  },
  {
    screenTitle: "Categories",
    screenIndex: "2",
    screenImage: "/img/customComponents/FilterRibbon_Category_002.png",
    screenDescription: "Categories and products screen",
    screenWidth: 108,
    screenHeight: 192,
    subScreenInfo: [
      {
        screenTitle: "Categories",
        screenIndex: "2A",
        screenImage: "",
        screenDescription: "Top or side category selection",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 33,
        areaPositionY: 5,
        areaPositionX: 0,
      },
      {
        screenTitle: "Categories",
        screenIndex: "2D",
        screenImage: "",
        screenDescription: "Category header image",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 35,
        areaPositionY: 40,
        areaPositionX: 0,
      },
      {
        screenTitle: "Products",
        screenIndex: "2B",
        screenImage: "",
        screenDescription: "Displayed products of selected category",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 80,
        areaPositionY: 80,
        areaPositionX: 0,
      },
      {
        screenTitle: "Cart button",
        screenIndex: "2C",
        screenImage: "",
        screenDescription: "Button to navigate to shopping cart screen",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 23,
        areaPositionY: 170,
        areaPositionX: 0,
      },
    ],
  },
  {
    screenTitle: "Article",
    screenIndex: "3",
    screenImage: "/img/customComponents/FilterRibbon_Product_002.png",
    screenDescription: "Article detail page - add to shopping cart",
    screenWidth: 108,
    screenHeight: 192,
    subScreenInfo: [
      {
        screenTitle: "Article details",
        screenIndex: "3C",
        screenImage: "",
        screenDescription: "Article detail information",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 80,
        areaPositionY: 0,
        areaPositionX: 0,
      },
      {
        screenTitle: "Article details",
        screenIndex: "3D",
        screenImage: "",
        screenDescription: "Article options",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 84,
        areaHeight: 48,
        areaPositionY: 83,
        areaPositionX: 13,
      },
      {
        screenTitle: "Amount buttons",
        screenIndex: "3A",
        screenImage: "",
        screenDescription: "Order amount buttons",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 76,
        areaHeight: 20,
        areaPositionY: 142,
        areaPositionX: 16,
      },
      {
        screenTitle: "Amount buttons",
        screenIndex: "3B",
        screenImage: "",
        screenDescription: "Add order button",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 55,
        areaHeight: 20,
        areaPositionY: 166,
        areaPositionX: 27,
      },
    ],
  },
  {
    screenTitle: "Cart",
    screenIndex: "4",
    screenImage: "/img/customComponents/FilterRibbon_Cart_001-FullHD.png",
    screenDescription: "List of total amount of ordered products and prices",
    screenWidth: 108,
    screenHeight: 192,
    subScreenInfo: [
      {
        screenTitle: "OrderPage",
        screenIndex: "4C",
        screenImage: "",
        screenDescription: "Cart page header",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 20,
        areaPositionY: 6,
        areaPositionX: 0,
      },
      {
        screenTitle: "OrderPage",
        screenIndex: "4D",
        screenImage: "",
        screenDescription: "List of articles on cart page",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 82,
        areaHeight: 91,
        areaPositionY: 30,
        areaPositionX: 14,
      },
      {
        screenTitle: "OrderPage",
        screenIndex: "4A",
        screenImage: "",
        screenDescription: "Button that navigates back to the category page",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 51,
        areaHeight: 23,
        areaPositionY: 149,
        areaPositionX: 3,
      },
      {
        screenTitle: "SendOrder",
        screenIndex: "4B",
        screenImage: "",
        screenDescription: "Button that sends the order",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 51,
        areaHeight: 23,
        areaPositionY: 149,
        areaPositionX: 54,
      },
      {
        screenTitle: "OrderPage",
        screenIndex: "4E",
        screenImage: "",
        screenDescription: "Amount of ordered items",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 51,
        areaHeight: 19,
        areaPositionY: 170,
        areaPositionX: 3,
      },
      {
        screenTitle: "SendOrder",
        screenIndex: "4F",
        screenImage: "",
        screenDescription: "Total price of order",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 51,
        areaHeight: 19,
        areaPositionY: 170,
        areaPositionX: 54,
      },
    ],
  },
  {
    screenTitle: "Pay",
    screenIndex: "5",
    screenImage: "/img/customComponents/FilterRibbon_Pay_002-FullHD.png",
    screenDescription: "The final payment screen",
    screenWidth: 108,
    screenHeight: 192,
    subScreenInfo: [
      {
        screenTitle: "Article details",
        screenIndex: "5A",
        screenImage: "",
        screenDescription: "Page header",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 60,
        areaPositionY: 6,
        areaPositionX: 0,
      },
      {
        screenTitle: "Article details",
        screenIndex: "5B",
        screenImage: "",
        screenDescription: "Custom fields",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 83,
        areaHeight: 46,
        areaPositionY: 73,
        areaPositionX: 13,
      },
      {
        screenTitle: "Article details",
        screenIndex: "5C",
        screenImage: "",
        screenDescription: "Total price on final payment screen",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 54,
        areaHeight: 17,
        areaPositionY: 130,
        areaPositionX: 27,
      },
      {
        screenTitle: "Article details",
        screenIndex: "5D",
        screenImage: "",
        screenDescription: "Pay button",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 54,
        areaHeight: 21,
        areaPositionY: 150,
        areaPositionX: 27,
      },
    ],
  },
];
